import $ from "jquery";

$(".js-references-masonry").masonry({
  percentPosition: true,
  columnWidth: ".masonry__item",
  itemSelector: ".masonry__item",
  gutter: 20
});
